import { render, staticRenderFns } from "./index_supply.vue?vue&type=template&id=643e32bd&"
import script from "./index_supply.vue?vue&type=script&lang=js&"
export * from "./index_supply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports